import {AddMobileDeviceDialog} from "@/features/user/addMobileDeviceDialog";
import {SidebarHelper} from "@/features/presenceboard/sidebarHelper";
import {UserSettingsChanger} from "@/shared/userSettingsChanger";
import {VideoIntroduction} from "@/features/onboarding/videoIntroduction";
import {StatusElementsHolder, statusElementsHolder} from "@/shared/recording/statusElementsHolder";
import {SecurityStatus} from "@/shared/securityStatus";
import {formatRunningDurationSince} from "@/shared/utils/datefunctions";
import {RunningEntry, StatusElementEntries} from "@/shared/timr";

$(function () {
	// Language selection dropdown submit
	$(".dropdown-menu-language > li > a").on("click", function (this: HTMLElement) {
		const language = $(this).data("language") as string;
		if (language) {
			$.ajax({
				url: "/timr/changeLanguage.json",
				type: "POST",
				data: {
					language: language
				},
				success: function () {
					location.reload();
				}
			});
		}
	});

	$("#sidebar-introductionVideo").click(function () {
		VideoIntroduction.show();
	});
	const mainUl = $(".sidebar-content-main ul.navigation");
	const footerUl = $(".sidebar-content-footer ul.navigation");

	mainUl.on("click", function () {
		if (mainUl.find("> li.active").has("ul.hidden-ul")) {
			footerUl.find("> li").removeClass("active");
			footerUl.find("ul").hide();
		}
	});

	footerUl.on("click", function () {
		if (footerUl.find("> li.active").has("ul.hidden-ul")) {
			mainUl.find("> li").removeClass("active");
			mainUl.find("ul").hide();
		}
	});

	let appLinkModal: AddMobileDeviceDialog;
	$(".sidebar-applink").click(function () {
		if (appLinkModal) {
			appLinkModal.open();
		} else {
			appLinkModal = new AddMobileDeviceDialog();
			appLinkModal.open();
		}
	});

	if ($(".header-message").length > 0) {
		const heightHeaderMessage = $(".header-message").height();
		const heightSidebar = "calc(100% - " + heightHeaderMessage + "px)";
		$(".sidebar-content").css("height", heightSidebar);
	}

	if ($("[data-working-time-duration], [data-project-time-duration], #runningDriveLogSidebarStatus, #requestApprovalSidebarStatus, #presenceBoardSidebarActiveUsersStatus").length > 0) {
		const updateSidebarStatusForElement = function (elm: JQuery, runningRecording: RunningEntry) {
			if (runningRecording) {
				elm.text(formatRunningDurationSince(runningRecording)).show();
			} else {
				elm.hide().text("");
			}
		};

		const updateSidebarStatus = function (statusElementEntries: StatusElementEntries) {
			if (statusElementEntries) {
				if (statusElementEntries.recordingStatusEntries) {
					updateSidebarStatusForElement($("[data-working-time-duration]"), statusElementEntries.recordingStatusEntries?.runningWorkingTime);
					updateSidebarStatusForElement($("[data-project-time-duration]"), statusElementEntries.recordingStatusEntries?.runningProjectTime);
					updateSidebarStatusForElement($("#runningDriveLogSidebarStatus"), statusElementEntries.recordingStatusEntries.runningDriveLog);
				}

				const requestApprovalSidebarNavElement = $("#nav-requests-requests-approval");
				const requestApprovalSidebarStatusElement = $("#requestApprovalSidebarStatus");
				const requestApprovalSidebarStatusMenuIcon = $("#requestApprovalSidebarStatusMenuIcon");
				if (SecurityStatus.isWorkingTimeRequestsEnabled() && statusElementEntries.workingTimeRequestsToApprove) {
					requestApprovalSidebarNavElement.show();
					requestApprovalSidebarStatusElement.show();
					requestApprovalSidebarStatusMenuIcon.show();
					requestApprovalSidebarStatusElement.text(statusElementEntries.workingTimeRequestsToApprove);
				} else {
					requestApprovalSidebarStatusElement.hide();
					requestApprovalSidebarStatusMenuIcon.hide();
				}

				// update sidebar badge containing count for relevant personal and manager (teamleader or multiuser) validations
				if (globals.savedValidationsEnabled) {
					updateValidationsBadge(statusElementEntries);
				}

				updatePresenceBoardActiveUserCount(statusElementEntries.presenceBoardActiveUsersCount);
			}
		};

		$(statusElementsHolder).on(StatusElementsHolder.EVENT_RECORDING_STATUS_CHANGED, function (e, statusElementEntries: StatusElementEntries) {
			updateSidebarStatus(statusElementEntries);
		});
		statusElementsHolder.activate();
		updateSidebarStatus(statusElementsHolder.getStatusElementEntries());
	}

	const navPresenceBoard = $("#nav-presence-board:not(.active)");
	// If the presence board is not allowed for this user the element doesn't exist
	if (navPresenceBoard.length > 0) {
		let timeoutId: number = null;
		navPresenceBoard.popover({
			trigger: "manual",
			placement: "right",
			container: ".page-content",
			html: true,
			// DEVNOTE: workaround for a bug with bootstrap popups and empty titles (calls content function twice)
			// https://github.com/twbs/bootstrap/issues/12563
			title: " ",
			// Template without .popover-title displays the popover right
			// Do not go over width 750px, otherwise the popover will sometimes display 3 columns
			template: `
				<div class="popover" style="min-width: 750px" role="tooltip"><div class="arrow"></div><div class="popover-content p-5" style="height: 400px; overflow-y: scroll"></div></div>
			`,
			content: () => {
				SidebarHelper.getPresenceBoardPopoverElement().then(
					(data: string) => $(".popover-content").html(data),
					(message: string) => $(".popover-content").html(message)
				);
				return SidebarHelper.createLoadingCards();
			}
		})
			// trigger the popover manually to prevent the popover from collapsing when the mouse leaves the nav element
			.on("mouseenter", function (this: HTMLElement) {
				// 500 ms delay between hover and show to prevent accidental requests
				timeoutId = window.setTimeout(() => {
					$(this).popover("show");
					// mouseleave of the popover
					$(".popover").on("mouseleave", () => {
						$(this).popover("hide");
					});
				}, 500);
			})
			// mouseleave of the nav element
			.on("mouseleave", function (this: HTMLElement) {
				if (timeoutId) {
					window.clearTimeout(timeoutId);
					timeoutId = null;
				}
				// after 300 ms check if the mouse is still not over the popover and hide it
				setTimeout(() => {
					if (!$(".popover:hover").length) {
						$(this).popover("hide");
					}
				}, 300);
			});
	}

	$("#widgetGuidesToggle").click((e) => {
		const $toggle = $(e.target);

		// Prevent action if client-level setting is disabled
		if ($toggle.data("client-enabled") === false) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		}

		const widgetGuidesEnabled = $toggle.is(":checked");
		new UserSettingsChanger("widgetGuidesEnabled")
			.changeSettingTo(widgetGuidesEnabled)
			.always(() => {
				window.location.reload();
			});
	});

	function updatePresenceBoardActiveUserCount(activeUserCount: number) {
		// if presence board is not allowed, no element with id "presenceBoardSidebarActiveUsersStatus" exists
		const presenceBoardSidebarActiveUsersStatus = $("#presenceBoardSidebarActiveUsersStatus");
		if (presenceBoardSidebarActiveUsersStatus.length > 0) {	// check if element exists
			if (activeUserCount && activeUserCount > 0) {
				presenceBoardSidebarActiveUsersStatus.show();
				presenceBoardSidebarActiveUsersStatus.text(activeUserCount);
			} else {
				presenceBoardSidebarActiveUsersStatus.hide();
			}
		}
	}

	/**
	 * Updates the validations badge. The content and tooltip is different based on the current user:
	 *  - Admin or group leader: "5/10"
	 *    Tooltip: Validations:
	 *  			- Personal: 5
	 *  			- Manager: 10
	 *  - Standard user: "5"
	 *  			- 5 Open Validations
	 */
	function updateValidationsBadge(statusElementEntries: StatusElementEntries): void {
		const {currentUserValidationCount, groupMemberValidationCount} = statusElementEntries;
		const validationsBadge = $("#validationsBadge");
		if (groupMemberValidationCount !== null) {
			// build manager content
			validationsBadge
				.toggle(currentUserValidationCount > 0 || groupMemberValidationCount > 0)
				.attr("title", messages.withArguments("validations.sidebar.badge.tooltip.manager", currentUserValidationCount, groupMemberValidationCount))
				.text(`${currentUserValidationCount}/${groupMemberValidationCount}`);
		} else {
			// build personal content
			validationsBadge
				.toggle(currentUserValidationCount > 0)
				.attr("title", messages.withArguments("validations.sidebar.badge.tooltip.personal", currentUserValidationCount))
				.text(currentUserValidationCount);
		}
	}
});
